import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { textEncodeBase64 } from '../../utils/encode';

@Injectable()
export class VerificationService {

  private verifierApiUrl = environment.identityApiUrl + '/Verifier';

  constructor(private http: HttpClient) { }

  public isEmailInUse(email: string) {
    const url = this.verifierApiUrl + `/IsEmailInUse?email=${textEncodeBase64(email)}`;
    return this.http
      .get<{ email: string; isEmailInUse: string }>(url);
  }

}
